import cx from 'classnames';
import React from 'react';
import { calculateIndicatorSvgAttributes } from '@tesla/design-system';
export const Indicator = ({ 'aria-label': ariaLabel, bright, circleProps = {}, className, color, label, size, ...rest }) => {
    const svgAttributes = calculateIndicatorSvgAttributes();
    return (React.createElement("svg", { "aria-label": ariaLabel || label, className: cx('tds-indicator', {
            [`tds-indicator--${size}`]: !!size,
            [`tds-status-color--${color}`]: bright,
            [`tds-status-color--${color}-pastel`]: !bright,
        }, className), xmlns: "http://www.w3.org/2000/svg", ...svgAttributes.container, ...rest },
        React.createElement("circle", { fill: "var(--tds-status-color--background-color)", ...svgAttributes.circle, ...circleProps })));
};
